<template>
	<div
		aria-hidden="true"
		class="animate-fade-in min-h-4 bg-white/10 rounded-lg p-4 [&_span]:bg-white/10 [&_span]:text-transparent [&_span]:rounded-lg [&_span]:block [&_span]:animate-pulse"
		:class="{
			'h-40': type === 'reservation-option',
		}"
	>
		<div v-if="type === 'start-option'" class="flex gap-4 items-center">
			<span class="size-12"></span>
			<span class="h-5 w-[40%]"></span>
		</div>

		<div v-if="type === 'reservation-option'" class="flex gap-4 items-stretch">
			<span class="w-30 min-h-30"></span>
			<div class="flex-1 flex flex-col gap-2">
				<span class="h-5 w-[50%]"></span>
				<span class="h-4 w-[70%]"></span>
				<span class="h-4 w-[60%]"></span>
				<span class="h-8 w-24 mt-auto self-end rounded-full!"></span>
			</div>
		</div>

		<slot v-else />
	</div>
</template>

<script setup lang="ts">
withDefaults(defineProps<{
	type?: 'custom' | 'start-option' | 'reservation-option'
}>(), {
	type: 'custom'
});
</script>
